import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=f835c8ae&"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNotifications.vue?vue&type=style&index=0&id=f835c8ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports